module.exports = __webpack_public_path__ + "account/assets/tiktok.6381e84c.svg";